var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #06e575;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        clip-path: url(#clip-path-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20127",
    "data-name": "Rectangle 20127",
    className: "cls-1",
    width: 200,
    height: 200,
    transform: "translate(1109 1660)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20126",
    "data-name": "Rectangle 20126",
    className: "cls-1",
    width: 132.127,
    height: 132.248
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_83",
    "data-name": "Mask Group 83",
    className: "cls-2",
    transform: "translate(-1109 -1660)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20360",
    "data-name": "Group 20360",
    transform: "translate(1143.286 1694.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20359",
    "data-name": "Group 20359",
    className: "cls-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9918",
    "data-name": "Path 9918",
    className: "cls-1",
    d: "M132.125,64.188v4.118a13.627,13.627,0,0,0-.448,3.064A65.944,65.944,0,1,1,.229,60.635C3.23,24.405,35.036-2.609,70.827.2A66.129,66.129,0,0,1,131.37,57.406c.321,2.334.093,4.691.756,6.781M54.562,127c36.245,6.8,69.694-19.365,72.971-55.311A61.831,61.831,0,1,0,54.562,127",
    transform: "translate(0 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9919",
    "data-name": "Path 9919",
    className: "cls-1",
    d: "M71.588,110.273a52.839,52.839,0,1,1,39.768-56.536,52.683,52.683,0,0,1-39.768,56.536M87.05,47.36l17.195-5.869a48.561,48.561,0,0,0-91.3,1.7l17.266,4.719a24.363,24.363,0,0,0,16.547-1.274c19.253-8.515,25.092,5.907,40.291.721M11.037,53.353a63.335,63.335,0,0,1,45.07,54.09,16.9,16.9,0,0,0,5.548.017,63.382,63.382,0,0,1,45.477-54.254L105.6,45.582,89.2,51.065a28.187,28.187,0,0,1-20.545-.885,24.881,24.881,0,0,0-20.583.4A26.405,26.405,0,0,1,30.229,52.1L11.842,47.293a12.341,12.341,0,0,0-.805,6.06m40.816,53.793A58.723,58.723,0,0,0,10.3,57.53a48.677,48.677,0,0,0,41.548,49.617m14.125-.015a48.687,48.687,0,0,0,41.5-49.608C84.942,64.236,68.333,84,65.977,107.132",
    transform: "translate(7.084 7.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9920",
    "data-name": "Path 9920",
    className: "cls-1",
    d: "M35.864,27.851a13.076,13.076,0,1,1-11.1,15.178,13.06,13.06,0,0,1,11.1-15.178m-.013,4.189a8.931,8.931,0,1,0,10.521,6.87,8.88,8.88,0,0,0-10.521-6.87",
    transform: "translate(28.313 31.952)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.84baaf74d8b2265840c2df938f736d66.svg";
export { ForwardRef as ReactComponent };